// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2SLse","fullScreen":"style_fullScreen__3jAFc","hidden":"style_hidden__aSbDv"};